import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SignatureAudit from '../../components/AuditViewer/SignatureAudit';
import AccessLogs from '../../components/AuditViewer/AccessLogs';
import DataChanges from '../../components/AuditViewer/DataChanges';
import FormSubmissions from '../../components/AuditViewer/FormSubmissions';
import './Audits.css';

const Audits = () => {
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('signatures');
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is authenticated and is an admin
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('userRole');
    
    if (!token) {
      navigate('/login');
      return;
    }
    
    if (role !== 'admin') {
      // Redirect non-admins to dashboard
      navigate('/dashboard');
      return;
    }
    
    setUserRole(role);
    setLoading(false);
  }, [navigate]);

  if (loading) {
    return <div className="audits-loading">Loading...</div>;
  }

  return (
    <div className="audits-page">
      <div className="audits-header">
        <h1>System Audit Logs</h1>
        <p className="audit-warning">This page is restricted to administrators only</p>
      </div>

      <div className="audit-tabs">
        <button 
          className={`audit-tab ${activeTab === 'signatures' ? 'active' : ''}`}
          onClick={() => setActiveTab('signatures')}
        >
          Document Signatures
        </button>
        <button 
          className={`audit-tab ${activeTab === 'forms' ? 'active' : ''}`}
          onClick={() => setActiveTab('forms')}
        >
          Form Submissions
        </button>
        <button 
          className={`audit-tab ${activeTab === 'access' ? 'active' : ''}`}
          onClick={() => setActiveTab('access')}
        >
          Access Logs
        </button>
        <button 
          className={`audit-tab ${activeTab === 'changes' ? 'active' : ''}`}
          onClick={() => setActiveTab('changes')}
        >
          Data Changes
        </button>
      </div>

      <div className="audit-content">
        {activeTab === 'signatures' && (
          <SignatureAudit />
        )}
        {activeTab === 'forms' && (
          <FormSubmissions />
        )}
        {activeTab === 'access' && (
          <AccessLogs />
        )}
        {activeTab === 'changes' && (
          <DataChanges />
        )}
      </div>

      <div className="audit-footer">
        <p>Audit logs are retained for compliance purposes and cannot be deleted.</p>
        <button 
          className="back-to-dashboard"
          onClick={() => navigate('/dashboard')}
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default Audits;